import { IconMagicSolid, StatusBadge, StatusBadgeStatuses } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import {
  GlobalSearchRecentConversationContentStyled,
  GlobalSearchRecentConversationIconStyled,
  GlobalSearchRecentConversationListStyled,
  GlobalSearchRecentConversationStyled,
  GlobalSearchRecentConversationLabelStyled,
  GlobalSearchRecentConversationsHeadingStyled,
} from './styles/GlobalSearchRecentConversationsStyled'
import { type RecentConversation } from '../../../../value-objects/RecentConversation'

interface IGlobalSearchRecentConversationsProps {
  conversations: RecentConversation[]
  onConversationClick: (conversation: RecentConversation) => void
}

export const GlobalSearchRecentConversations = ({
  conversations,
  onConversationClick,
}: IGlobalSearchRecentConversationsProps) => {
  const intl = useProcurifyIntl()

  return (
    <>
      <GlobalSearchRecentConversationsHeadingStyled color='textSecondary'>
        {intl.formatMessage(messages.heading)}
      </GlobalSearchRecentConversationsHeadingStyled>
      <GlobalSearchRecentConversationListStyled
        aria-label={intl.formatMessage(messages.listAriaLabel)}
      >
        {conversations.map((conversation) => (
          <li key={conversation.conversationId}>
            <GlobalSearchRecentConversationStyled
              type='button'
              data-analytics-id='global-command-recent-conversation'
              onClick={() => onConversationClick(conversation)}
            >
              <GlobalSearchRecentConversationIconStyled aria-hidden='true'>
                <IconMagicSolid size={24} color='ai' />
              </GlobalSearchRecentConversationIconStyled>
              <GlobalSearchRecentConversationContentStyled>
                <GlobalSearchRecentConversationLabelStyled inline>
                  {conversation.label}
                </GlobalSearchRecentConversationLabelStyled>
                <StatusBadge
                  type={StatusBadgeStatuses.INCOMPLETE}
                  size='small'
                  text={intl.formatMessage(messages.draftStatus)}
                />
              </GlobalSearchRecentConversationContentStyled>
            </GlobalSearchRecentConversationStyled>
          </li>
        ))}
      </GlobalSearchRecentConversationListStyled>
    </>
  )
}
